import React from "react";
import Image from "next/image";
import Breadcrumb from "@/Components/Breadcrumb/Breadcrumb";

interface BannerProps {
  block: {
    title: string;
    sub_title: string;
  };
  breadcrumbs: {
    item: { label: string; href: string }[];
  };
}

const Banner: React.FC<BannerProps> = ({ block, breadcrumbs }) => {
  return (
    <>
      <section className="request-proposal-banner bg-background-dark  py-[120px] lg:py-[150px] xl:pb-[240px]  relative z-0">
        {/* Shapes */}
        <div className="banner-shape-1 absolute top-[0px] left-0 z-[1] w-[50%] md:w-[40%]">
          <Image
            src="/images/banner-left-layer-mobile.png"
            alt="Banner Shape"
            width={571}
            height={571}
            className="w-full h-full md:hidden"
          />
          <Image
            src="/images/banner-left-layer-tablet.png"
            alt="Banner Shape"
            width={571}
            height={571}
            className="w-full h-full hidden md:block lg:hidden"
          />
          <Image
            src="/images/banner-left-layer-desktop.png"
            alt="Banner Shape"
            width={571}
            height={571}
            className="w-full h-full hidden lg:block"
          />
        </div>
        <div className="banner-shape-1 absolute bottom-0 right-0 z-[-1] ">
          <Image
            src="/images/banner-right-layer-mobile.png"
            alt="Banner Shape"
            width={471}
            height={471}
            className="object-cover w-full h-full md:hidden"
          />
          <Image
            src="/images/banner-right-layer-tablet.png"
            alt="Banner Shape"
            width={471}
            height={471}
            className="object-cover w-full h-full hidden md:block lg:hidden"
          />
          <Image
            src="/images/banner-right-layer-desktop.png"
            alt="Banner Shape"
            width={471}
            height={471}
            className="object-cover w-full h-full hidden lg:block"
          />
        </div>
        <div className="container lg:p-[0px_24px]!">
          <div>
            {breadcrumbs?.item?.length > 0 && (
              <Breadcrumb
                items={breadcrumbs?.item ?? []}
                className="mb-[16px] lg:mb-[32px] xl:mb-[40px] flex justify-center"
              />
            )}
            <h1 className="text-white text-[28px] xm:text-[36px] lg:text-[56px] xl:text-[80px] xl:leading-[104px] lg:leading-[72px] xm:leading-[46.8px] font-extrabold text-center uppercase">
              {block.title}
            </h1>
            <p className="text-secondary-text-white text-[16px] xl:text-[18px] leading-[22px] xl:leading-[25.2px] font-normal text-center mt-4">
              {block.sub_title}
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Banner;
